import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Typography } from '@mui/material';
import { TitledAppBar } from 'src/components/common/TitledAppBar';
import { EmptyState } from 'src/components/common/EmptyState';
import { isAuthorizedQuery } from 'src/selectors/isAuthorizedQuery';
import { useQuerySetsConfig } from 'src/hooks/useQuerySetsConfig';
import { SetsConfigDetails } from 'src/components/SetsConfigDetails/SetsConfigDetails';
import { SetsConfigDetailsSkeleton } from 'src/components/SetsConfigDetails/SetsConfigDetailsSkeleton';

export const SetsConfigDetailsPage = (): JSX.Element => {
    const { productKey } = useParams();
    const accessToken = useRecoilValue(isAuthorizedQuery);
    const { data: config, isLoading } = useQuerySetsConfig(accessToken, productKey ?? '');

    if (isLoading) {
        return (
            <>
                <TitledAppBar title="Sets Configuration Tool" />
                <SetsConfigDetailsSkeleton />
            </>
        );
    }

    if (!config) {
        return (
            <>
                <TitledAppBar title="Sets Configuration Tool" />
                <EmptyState>
                    <Typography align="center" variant="h6">
                        {`No config found for ${productKey}`}
                    </Typography>
                </EmptyState>
            </>
        );
    }

    return <SetsConfigDetails initialConfig={config} />;
};
